import EmptyCard from './empty_card'

export default EmptyCard
